import { useTranslation } from "react-i18next";
import { HeroChip } from "/app/src/components/HeroUi/Chip";
import PowerPickChart from "./charts/powerPickChart";
import Box from "/app/src/components/generic/components/box";
import HeroDivider from "/app/src/components/HeroUi/Divider";

/**
 * Generic Connection Status Component
 * @param {Object} props
 * @param {string} props.connectionName - Name of the connection
 * @param {Object} props.data - Data for the chart
 * @param {boolean} props.isConnected - Connection status
 * @returns JSX.Element
 */
function ConnectionStatusCard({ connectionName, data, isConnected }) {
  const { t } = useTranslation();
  return (
    <Box>
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-neutral-charcoal font-archivo text-lg mb-0 font-medium">
            {connectionName}
          </h3>
          <h4 className="text-neutral-charcoal font-archivo text-sm mb-0 font-medium">
            {t("translation:connection_status")}
          </h4>
        </div>
      </div>
      <HeroDivider className="my-4" />
      <div className="flex items-center justify-end">
        {isConnected ? (
          <HeroChip variant="dot" color="success" size="sm">
            {t("translation:connected")}
          </HeroChip>
        ) : (
          <HeroChip variant="dot" color="danger" size="sm">
            {t("translation:not_connected")}
          </HeroChip>
        )}
      </div>
      <PowerPickChart data={data} />
    </Box>
  );
}

export default ConnectionStatusCard;
